<template>
  <v-data-table :headers="headers" :items="followups">
    <template v-slot:item.actions="{ item }">
      <v-row>
        <FollowUpsTableActions :followup="item" />
      </v-row>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import FollowUpsTableActions from "@/components/forms/FollowUpsTableActions";

export default {
  name: "FollowUpsTable",
  components: {
    FollowUpsTableActions,
  },
  data: () => ({
    id: null,
    deleteDialog: false,
    completeDialog: false,
    editDialog: false,
    edit: {
      datetime: null,
      description: null,
      priority: 3,
    },
    headers: [
      { text: "Date/Time", value: "datetime" },
      { text: "Description", value: "description" },
      { text: "Priority", value: "priority" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    setId(id) {
      this.id = id;
    },
    setFollowUp(item) {
      this.id = item.id;
      this.edit.datetime = new Date(item.datetime);
      this.edit.description = item.description;
      const priorityIndex = this.priorities.findIndex(
        (priority) => priority.value === item.priority
      );
      this.edit.priority = this.priorities[priorityIndex].key;
    },
    completedFollowup() {
      this.$axios
        .post("/followup/update", {
          id: this.id,
          followup: { completed: 1 },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.completeDialog = false;
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
    deleteFollowup() {
      this.$axios
        .post("/followup/delete", {
          id: this.id,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.deleteDialog = false;
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
    editFollowup() {
      this.$axios
        .post("/followup/update", {
          id: this.id,
          followup: this.edit,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.deleteDialog = false;
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      followups: "followups/followups",
      priorities: "followups/priorities",
    }),
  },
};
</script>

<style>
.clickable {
  cursor: pointer;
}
.clickable:hover {
  color: red;
}
</style>